import httpClient from './Http'
import categoryService from './CategoryService'
import geoLocationService from './GeoLocationService'

export default {
	emailExists(email){
		return httpClient.get(`/user/email-exists?emailAddress=${email}`);
	},
	
	// category groups
	getProWorkTypes(){
		return categoryService.getCategoryGroups();
	},
	
	upgradeUserToPro(proProfile, city, state, zipCode, latitude, longitude, isNewUser){
		const proRegistration = {
			proProfile : proProfile,
            city: city,
            state: state,
			verifiedZipCode: zipCode,
			latitude: latitude,
			longitude: longitude,
      newUser: isNewUser,
		};
		
		return httpClient.post(`/pro/upgrade`, proRegistration);
	},
	
	getProTagsByPrefix(prefix){
		return httpClient.get(`/tags/pro?q=${prefix}`);
	},
	
	getLatLngForZipCode(zipCode){
		return geoLocationService.getLatLngForZipCode(zipCode);
	},

    getGeoLocationResponseForZipCode(zipCode){
        return geoLocationService.getGeoLocationResponseForZipCode(zipCode);
    },

    search(queryStr, skipHistoryPushState) {
        queryStr = queryStr || '';
        let apiPath = `/pro/search/user${queryStr}`;
        console.log("apiPath", apiPath);

        let result = httpClient.get('/api' + apiPath);

        if(!skipHistoryPushState) {
            window.history.pushState(null, null, apiPath);
        }

        return result;
    },

    getConversations() {
        return httpClient.get('/api/conversation/conversations');
    },
}



// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/api/UserService.js